import { FGCustomPanel, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { DogDnaApi, MarkerListDto } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IDnaMarkerSaveAllPanelProps {
  onSave: () => void;
  dogId: number;
}

const TitleContainer = styled.div`
  min-height: 0px;
  margin-top: 0.5rem;
  margin-left: 1rem;
`;

export const DnaMarkerSaveAllPanel: React.FunctionComponent<IDnaMarkerSaveAllPanelProps> = ({ onSave, dogId }) => {
  const { t } = useTl();
  const api = useApiService(DogDnaApi);
  const save = React.useCallback(
    async (d: MarkerListDto) => {
      await api.saveNewDnaMarkerResult(d);
      onSave();
      return dogId;
    },
    [api, dogId, onSave]
  );
  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: () => api.getDnaMarkers(dogId),
      saveApiFn: (d) => save(d),
      deleteApiFn: (d) => {},
    },
    []
  );

  return (
    <div style={{ marginRight: "1rem", marginTop: "1rem" }}>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={true}
        loading={loading}
        showDeleteButton={false}
        saving={saving}
        minLabelWidth={100}
      >
        <FGCustomPanel>
          {(ctx) => (
            <div>
              {ctx.formik.values.markers.map((value, index) => (
                <FieldGroup
                  columns={2}
                  fieldsetProps={{
                    title: <TitleContainer>{value.marker}</TitleContainer>,
                  }}
                >
                  <FGTextInput name={`markers[${index}].value1`} label={t(ETLCodes.Value1)} />
                  <FGTextInput name={`markers[${index}].value2`} label={t(ETLCodes.Value2)} />
                </FieldGroup>
              ))}
            </div>
          )}
        </FGCustomPanel>
      </SmallFormGenerator>
    </div>
  );
};
